import { useCallback, useContext } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models'
import { SingleInspectionContext } from '../../providers/SingleInspectionProvider/SingleInspectionProvider'
import { useUpdateInspectionMutation } from '../../redux/api/inspectionApi'
import { DviSingleInspectionSummaryContent } from './DviSingleInspectionSummaryContent'

export const DviSingleInspectionSummaryNotCached = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const { accessToken } = useAccessTokenAndShopId()
  const {
    inspectionWithRelated: inspection,
    repairOrder,
    vehicle,
    customer,
    isLoading
  } = useContext(SingleInspectionContext)
  const [updateInspection] = useUpdateInspectionMutation()

  const handleStartInspection = useCallback(
    (isReopen: boolean) => {
      if (inspection === undefined) {
        return
      }
      updateInspection({
        authorization: accessToken,
        inspectionEntry: {
          ...inspection,
          info: {
            ...inspection.info!,
            started: isReopen ? inspection.info!.started : new Date(),
            finished: undefined,
            advisorCompleteTime: undefined
          }
        }
      }).then(() =>
        navigate(generatePath(AppRoutes.DVI_SINGLE_INSPECTION, { id: id! }))
      )
    },
    [accessToken, id, inspection, navigate, updateInspection]
  )
  const handleAssignTech = useCallback(
    (tech: string) => {
      if (inspection === undefined) {
        return
      }
      updateInspection({
        authorization: accessToken,
        inspectionEntry: {
          ...inspection!,
          info: {
            ...inspection!.info!,
            tech: tech || undefined
          }
        }
      })
    },
    [accessToken, inspection, updateInspection]
  )

  return (
    <DviSingleInspectionSummaryContent
      {...{
        repairOrder,
        vehicle,
        customer,
        isLoading,
        inspection,
        handleStartInspection,
        handleAssignTech
      }}
    />
  )
}
